import { useEffect, useState } from "react";
import { Upload, Download, X } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Policies() {
  const [policy, setPolicy] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [bust, setBust] = useState(Date.now());

  const load = () => api.get("/policies").then((r) => setPolicy(r.data && r.data.id ? r.data : null)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post("/admin/policies", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Policies uploaded");
      setBust(Date.now());
      load();
    } catch (err) { toast.error(formatApiError(err)); }
    setUploading(false);
  };

  return (
    <div data-testid="admin-policies">
      <h1 className="font-heading text-3xl font-black uppercase tracking-tight mb-6">Zavi Policies</h1>
      <p className="text-white/50 text-sm mb-8 max-w-2xl">Upload a single policy document (PDF preferred). It replaces any existing one. Parents can view or download it from their portal.</p>

      <div className="border border-white/10 bg-[#0A0A0A] p-8">
        {policy ? (
          <>
            <div className="flex flex-wrap items-center justify-between gap-4 mb-5">
              <div>
                <p className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-semibold">Currently Live</p>
                <h2 className="font-heading text-lg font-black mt-1">{policy.filename}</h2>
                <p className="text-white/40 text-xs mt-1">Uploaded {new Date(policy.uploaded_at).toLocaleString("en-IN")}</p>
              </div>
              <div className="flex gap-3">
                <a href={`${BACKEND_URL}/api/policies/file?v=${bust}`} target="_blank" rel="noreferrer"
                  className="flex items-center gap-2 text-[#D4AF37] text-xs uppercase tracking-widest border border-[#D4AF37]/50 px-4 py-2 hover:bg-[#D4AF37] hover:text-black" data-testid="policy-view">
                  <Download size={13} /> View / Download
                </a>
              </div>
            </div>
          </>
        ) : (
          <p className="text-white/40 text-sm mb-5" data-testid="policy-empty">No policy document uploaded yet. Parents will not see this section until you upload.</p>
        )}
        <label className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-xs px-6 py-3 rounded-sm hover:bg-[#F3D059] cursor-pointer" data-testid="policy-upload-label">
          <Upload size={14} /> {uploading ? "Uploading..." : policy ? "Replace Document" : "Upload Document"}
          <input type="file" accept="application/pdf,image/*" onChange={upload} className="hidden" disabled={uploading} data-testid="policy-upload-input" />
        </label>
      </div>
    </div>
  );
}
